

import {uuid4} from "@capacitor/core/dist/esm/util";
import {State} from "@/store/state";
import {Mutation, MutationTree} from "vuex";

export enum Mutations{
    // AddProject = "addProject",
}
export type MutationDefinition = {
    [P in Mutations]: Mutation<State>;
}
interface BaseMutationPayloadWithType {
    type: Mutations;
}

export const mutations: MutationTree<State> & MutationDefinition = {

    // [Mutations.AddProject]: (state: State, payload: string) => {
    //     const newId = uuid4();
    //     state.projects.push({
    //         id: newId,
    //         name: payload
    //     })
    //     state.currentProject = newId
    //     state.project = {
    //         id:newId,
    //         name: "",
    //         characters: [],
    //         stage: {
    //             currentscene: null,
    //             scenes: []
    //         }
    //     }
    //     return state;
    // },

};
